import React from 'react';
import { ELEMENT_LINK } from '@udecode/slate-plugins';
import PropTypes from 'prop-types';

import isUrl from '../../../../utils/isUrl';

const Link = ({ children, element, ...props }) => (
  <a href={element.url} style={element.style} {...props}>
    {children}
  </a>
);

const serializableLinkElement = {
  link: {
    component: Link,
    type: ELEMENT_LINK,
    isUrl,
    rootProps: {
      className: 'slate-link',
      target: '_blank',
      rel: 'noopener noreferrer',
    },
  },
};

Link.propTypes = {
  children: PropTypes.node,
  attributes: PropTypes.elementType,
  element: PropTypes.shape({
    url: PropTypes.string.isRequired,
    style: PropTypes.string.isRequired,
  }).isRequired,
};

Link.defaultProps = {
  children: null,
  attributes: [],
};

export default serializableLinkElement;
